/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".support-hubspot-form[_ngcontent-%COMP%]{padding:20px 20px 0}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/mmi/support-form/support-form.component.scss.shim.ngstyle.js.pre-build-optimizer.js